import {
  AbilityBuilder,
  MongoAbility,
  createMongoAbility,
} from '@casl/ability';
import { ViewContext } from 'src/store/user-store';
import { siteContextPermissions } from './site-context-permissions';
import { tenantContextPermissions } from './tenant-context-permissions';

type CRUD = 'create' | 'read' | 'update' | 'delete';
type SUBJECTS =
  | 'OrganizationDetails'
  | 'Password'
  | 'TenantAuditLogs'
  | 'EmployeesGroupEmployees'
  | 'BookingRules'
  | 'EmployeesGroupBookingRules'
  | 'EmployeesGroupSpaceGroups'
  | 'EmployeesGroupBookings'
  | 'CalendarIntegration';

type Abilities = [CRUD, SUBJECTS];

interface TenantAdministrator {
  userToken: string;
}

type EmployeesActions = CRUD | 'upload' | 'changeGroup';

type EmployeesAbilities = [EmployeesActions, 'Employees'];

type EmployeesGroupsActions = CRUD | 'setAsDefault' | 'removeFromDefault';

type EmployeesGroupsAbilities = [EmployeesGroupsActions, 'EmployeesGroups'];

type TenantAdministratorsActions =
  | CRUD
  | 'updatePhoneNumber'
  | 'updateRole'
  | 'resendInvitation';

type TenantAdministratorsAbilities = [
  TenantAdministratorsActions,
  'TenantAdministrators' | TenantAdministrator,
];

type SpacesActions = CRUD | 'upload' | 'block' | 'unblock' | 'map';

type SpacesAbilities = [SpacesActions, 'Spaces'];

type SpaceGroupsActions =
  | CRUD
  | 'manageEmployeeGroups'
  | 'assignSpaces'
  | 'removeSpaces';

type SpaceGroupsAbilities = [SpaceGroupsActions, 'SpaceGroups'];

type BookingsActions =
  | CRUD
  | 'download'
  | 'confirmPresence'
  | 'finish'
  | 'cancel';

type BookingsAbilities = [BookingsActions, 'Bookings'];

type IssuesActions = CRUD | 'download';

type IssuesAbilities = [IssuesActions, 'Issues'];

type StatisticsActions = 'read' | 'download';

type StatisticsAbilities = [StatisticsActions, 'Statistics'];

export type AppAbility = MongoAbility<
  | Abilities
  | TenantAdministratorsAbilities
  | EmployeesAbilities
  | EmployeesGroupsAbilities
  | SpacesAbilities
  | SpaceGroupsAbilities
  | BookingsAbilities
  | IssuesAbilities
  | StatisticsAbilities
>;

export type Role = 'owner' | 'admin' | 'readonly' | 'master';

export function definePermissions(
  viewContext: ViewContext,
  role: Role,
  userToken: string,
  isSSOUser: boolean,
) {
  const builder = new AbilityBuilder<AppAbility>(createMongoAbility);

  switch (viewContext) {
    case 'tenant':
      tenantContextPermissions(builder, role, userToken, isSSOUser);
      break;
    case 'site':
      // siteContextPermissions(builder, role, userToken);
      siteContextPermissions();
      break;
    default:
      break;
  }

  return builder.build();
}
